/* eslint-disable @typescript-eslint/no-use-before-define */ /* eslint-disable @typescript-eslint/naming-convention */ import { isEmpty } from 'lodash';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT as API_DATE_FORMAT } from 'api/models';
const formatDate = (date, format)=>moment(date).format(format !== null && format !== void 0 ? format : API_DATE_FORMAT);
export var EntityType = /*#__PURE__*/ function(EntityType) {
    EntityType[EntityType["Phase"] = 0] = "Phase";
    EntityType[EntityType["Task"] = 1] = "Task";
    EntityType[EntityType["Sprint"] = 2] = "Sprint";
    return EntityType;
}({});
export const DependencyTypesValues = {
    SS: 0,
    SF: 1,
    FS: 2,
    FF: 3
};
export const DependencyTypes = {
    0: 'SS',
    1: 'SF',
    2: 'FS',
    3: 'FF'
};
export const DependencyTypesFull = {
    0: 'Start to Start',
    1: 'Start to Finish',
    2: 'Finish to Start',
    3: 'Finish to Finish'
};
export const DependencyTypesEnum = {
    START_TO_START: 0,
    START_TO_FINISH: 1,
    FINISH_TO_START: 2,
    FINISH_TO_FINISH: 3
};
export const DependencyTypesEnumReverse = {
    0: 'START_TO_START',
    1: 'START_TO_FINISH',
    2: 'FINISH_TO_START',
    3: 'FINISH_TO_FINISH'
};
export var DateType = /*#__PURE__*/ function(DateType) {
    DateType["StartDate"] = "startDate";
    DateType["DueDate"] = "dueDate";
    return DateType;
}({});
const SAME_PHASE_TASKS_MOVED_MAX_LIMIT = 5;
export const isWeekEnd = (date)=>[
        0,
        6
    ].includes(moment(date).day());
/**
 * moment `weeksInYear` util is available in 2.6
 * while the current moment version is at 2.29
 * hence created the following util to avoid version upgrade.
 */ const getWeeksInYear = (date)=>{
    let _date = moment(date).endOf('year');
    const year = moment(date).year();
    /**
   * Because the first day of the first week does not always fall on the first day of the year,
   * sometimes the week-year will differ from the month year.
   * For example, in the US, the week that contains Jan 1 is always the first week.
   * In the US, weeks also start on Sunday.
   * If Jan 1 was a Monday, Dec 31 would belong to the same week as Jan 1, and thus the same week-year as Jan 1.
   * Dec 30 would have a different week-year than Dec 31.
   * Ref: https://momentjs.com/docs/#/get-set/week-year/
   */ while(_date.weekYear() !== year){
        _date = moment(_date).subtract(1, 'd');
    }
    return _date.week();
};
const getDateDiff = (_date1, _date2)=>{
    return moment(formatDate(_date1)).diff(moment(formatDate(_date2)), 'days');
};
export const getDaysDiff = (_date1, _date2, allowWeekend)=>{
    if (allowWeekend) {
        return Math.round(moment(_date1).endOf('day').diff(moment(_date2).startOf('day'), 'days', true));
    }
    const date1 = moment(_date1);
    const date2 = moment(_date2);
    let daysDiff = Math.round(date1.diff(date2, 'days', true));
    let week1 = date1.week();
    let week2 = date2.week();
    /** Year end handling */ if (date1.isAfter(date2) && week1 < week2) {
        week1 = getWeeksInYear(date2) + week1;
    } else if (date2.isAfter(date1) && week2 < week1) {
        week2 = getWeeksInYear(date1) + week2;
    }
    const weekDiff = Math.abs(week2 - week1);
    const direction = daysDiff < 0 ? -1 : 1;
    daysDiff = Math.abs(daysDiff);
    if (weekDiff > 0) {
        if (isWeekEnd(date1) || isWeekEnd(date2)) {
            daysDiff -= (weekDiff - 1) * 2;
        } else {
            daysDiff -= weekDiff * 2;
        }
    }
    return daysDiff * direction;
};
export const getDaysDiff2 = (_date1, _date2, allowWeekend)=>{
    if (allowWeekend) {
        return Math.round(moment(_date1).endOf('day').diff(moment(_date2).startOf('day'), 'days', true));
    }
    const date1 = moment(_date1).startOf('day');
    const date2 = moment(_date2).startOf('day');
    // Get total calendar days between dates
    const totalDays = Math.abs(date1.diff(date2, 'days'));
    // Calculate complete weeks
    const completeWeeks = Math.floor(totalDays / 7);
    // Calculate remaining days
    const remainingDays = totalDays % 7;
    // Each complete week has 5 working days
    let businessDays = completeWeeks * 5;
    // Handle remaining days
    const startDay = moment.min(date1, date2).day();
    for(let i = 0; i < remainingDays; i += 1){
        const currentDay = (startDay + i) % 7;
        if (currentDay !== 0 && currentDay !== 6) {
            businessDays += 1;
        }
    }
    // Apply direction
    return date1.isAfter(date2) ? businessDays : -businessDays;
};
export const addDays = (date, daysCount, allowWeekend)=>{
    if (allowWeekend) {
        return moment(date).add(daysCount - 1, 'day');
    }
    let newDate = moment(date);
    const direction = daysCount < 0 ? -1 : 1;
    let _daysCount = Math.abs(daysCount);
    if ([
        0,
        6
    ].includes(moment(date).day())) {
        let tempNewDate = moment(newDate);
        while(_daysCount > 0 && [
            0,
            6
        ].includes(tempNewDate.add(direction, 'day').day())){
            tempNewDate = moment(newDate);
            _daysCount -= 1;
            newDate = newDate.add(direction, 'day');
        }
    }
    while(_daysCount > 0){
        const tempNewDate = moment(newDate);
        if (![
            0,
            6
        ].includes(tempNewDate.add(direction, 'day').day())) {
            _daysCount -= 1;
        }
        newDate = newDate.add(direction, 'day');
    }
    return newDate;
};
export const subtractDays = (date, daysCount)=>{
    let newDate = moment(date);
    const direction = daysCount < 0 ? -1 : 1;
    let _daysCount = Math.abs(daysCount);
    if ([
        0,
        6
    ].includes(moment(date).day())) {
        let tempNewDate = moment(newDate);
        while(_daysCount > 0 && [
            0,
            6
        ].includes(tempNewDate.subtract(direction, 'day').day())){
            tempNewDate = moment(newDate);
            _daysCount -= 1;
            newDate = newDate.subtract(direction, 'day');
        }
    }
    while(_daysCount > 0){
        const tempNewDate = moment(newDate);
        if (![
            0,
            6
        ].includes(tempNewDate.subtract(direction, 'day').day())) {
            _daysCount -= 1;
        }
        newDate = newDate.subtract(direction, 'day');
    }
    return newDate;
};
export const getDuration = (_startDate, _dueDate, allowWeekend)=>{
    if (allowWeekend) {
        return getDaysDiff(_dueDate, _startDate, allowWeekend);
    }
    let duration = 0;
    let startDate = moment(_startDate);
    const dueDate = moment(_dueDate);
    const startDay = startDate.day();
    const dueDay = dueDate.day();
    if (startDate.isSame(dueDate, 'day')) {
        return 1;
    }
    while(startDate.isSameOrBefore(dueDate, 'day')){
        if (![
            0,
            6
        ].includes(startDate.day())) {
            duration += 1;
        }
        startDate = startDate.add(1, 'day');
    }
    if (startDay === 0) {
        duration += 1;
    } else if (startDay === 6) {
        duration += 2;
    }
    if ([
        0,
        6
    ].includes(dueDay) && (![
        0,
        6
    ].includes(startDay) || dueDate.diff(moment(_startDate), 'days') > 5)) {
        if (dueDay === 6) {
            duration += 1;
        } else if (dueDay === 0) {
            duration += 2;
        }
    }
    return duration;
};
export const getCurrentDuration = (id, _startDate, _dueDate, childNodes)=>{
    var _Object_values;
    const countedWeekends = [];
    const blackListedWeekends = [];
    if (isWeekEnd(_startDate)) {
        if (!blackListedWeekends.includes(_startDate)) {
            blackListedWeekends.push(_startDate, formatDate(moment(_startDate).day() === 6 ? moment(_startDate).add(1, 'day') : moment(_startDate).subtract(1, 'day')));
        }
    }
    if (isWeekEnd(_dueDate)) {
        if (!blackListedWeekends.includes(_dueDate)) {
            blackListedWeekends.push(_dueDate, formatDate(moment(_dueDate).day() === 6 ? moment(_dueDate).add(1, 'day') : moment(_dueDate).subtract(1, 'day')));
        }
    }
    (_Object_values = Object.values(childNodes)) === null || _Object_values === void 0 ? void 0 : _Object_values.forEach((child)=>{
        if (!child) {
            return;
        }
        const { startDate, dueDate } = child;
        if (isWeekEnd(startDate) && !countedWeekends.includes(startDate) && !blackListedWeekends.includes(startDate)) {
            countedWeekends.push(startDate, formatDate(moment(startDate).day() === 6 ? moment(startDate).add(1, 'day') : moment(startDate).subtract(1, 'day')));
        }
        if (isWeekEnd(dueDate) && !countedWeekends.includes(dueDate) && !blackListedWeekends.includes(dueDate)) {
            countedWeekends.push(dueDate, formatDate(moment(dueDate).day() === 6 ? moment(dueDate).add(1, 'day') : moment(dueDate).subtract(1, 'day')));
        }
    });
    return getDuration(_startDate, _dueDate) + countedWeekends.length;
};
export const getNewDates = (date, duration, type)=>{
    let newStartDate;
    let newDueDate;
    if (duration === 0) {
        return [
            date,
            date
        ];
    }
    if (type === "startDate") {
        newStartDate = date;
        newDueDate = formatDate(addDays(newStartDate, duration - 1));
    } else {
        newDueDate = date;
        newStartDate = formatDate(subtractDays(date, duration - 1));
    }
    return [
        newStartDate,
        newDueDate
    ];
};
export const getChildNodeIds = (id, lookup)=>{
    // Recursive call may pass a childId that isn't present in `lookup`
    // (deleted task / stale tree mid-update). Guard before destructure so
    // we don't throw `Cannot destructure property 'children' of 'lookup[id]'
    // as it is undefined.` (~4 events/3d across multiple tenants on current
    // build per Datadog).
    const node = lookup[id];
    if (!node) {
        return [];
    }
    const { children } = node;
    return children && children.length > 0 ? [
        ...children,
        ...children.reduce((result, childId)=>{
            result.push(...getChildNodeIds(childId, lookup));
            return result;
        }, [])
    ] : [];
};
export const getTaskParentNodeIds = (id, tasks)=>{
    if (!tasks[id]) {
        return [];
    }
    const { parent } = tasks[id];
    return parent && tasks[parent] ? [
        parent,
        ...getTaskParentNodeIds(parent, tasks)
    ] : [];
};
export const getParentNodeIds = (id, lookup)=>{
    // Recursive call may pass a parentId that isn't present in `lookup`
    // (deleted task / stale tree mid-update). Guard before destructure so we
    // don't throw `Cannot destructure property 'parent' of 'lookup[id]' as it
    // is undefined.` — same hardening already applied to getChildNodeIds /
    // getTaskParentNodeIds above.
    const node = lookup[id];
    if (!node) {
        return [];
    }
    const { parent } = node;
    return parent ? [
        parent,
        ...getParentNodeIds(parent, lookup)
    ] : [];
};
const shiftDate = (currentDate, dateDiff, _allowWeekend)=>{
    if (dateDiff === 0) {
        return currentDate;
    }
    // const newDate = _allowWeekend
    //   ? moment(currentDate).add(dateDiff, 'days')
    //   : addDays(currentDate, dateDiff);
    const newDate = addDays(currentDate, dateDiff, _allowWeekend);
    // if (_allowWeekend || ![0, 6].includes(newDate.day())) {
    //   return newDate.format();
    // }
    // const targetDayIndex =
    //   newDate.day() === 6 ? (dateDiff > 0 ? 8 : 5) : dateDiff > 0 ? 1 : -2;
    return newDate.format();
};
export const getDragNewDates = (task, dragDistance, allowWeekend)=>{
    const { startDate, dueDate } = task;
    const currentDuration = getDuration(startDate, dueDate, allowWeekend);
    const newStartDate = shiftDate(startDate, dragDistance, allowWeekend);
    const newEndDate = addDays(newStartDate, currentDuration - 1, allowWeekend).endOf('day').format();
    return [
        newStartDate,
        newEndDate
    ];
};
export const getAutoCorrections = (phases, tasks, sprints, options)=>{
    var _ref;
    const updates = {};
    const nodesLookup = {
        ...phases,
        ...tasks,
        ...sprints
    };
    const allowWeekend = (_ref = options === null || options === void 0 ? void 0 : options.allowWeekend) !== null && _ref !== void 0 ? _ref : false;
    const getNode = (id)=>({
            ...nodesLookup[id],
            ...updates[id]
        });
    const updateNode = (id, nodeUpdates)=>{
        if (!updates[id] && !nodesLookup[id]) {
            return;
        }
        updates[id] = {
            ...updates[id] || {
                id,
                type: nodesLookup[id].type
            },
            ...nodeUpdates
        };
    };
    const markStartDateVerified = (id)=>{
        nodesLookup[id] = {
            ...nodesLookup[id],
            startDateVerified: true
        };
    };
    const markDueDateVerified = (id)=>{
        nodesLookup[id] = {
            ...nodesLookup[id],
            dueDateVerified: true
        };
    };
    const isAllNodesVerified = ()=>{
        return !Object.values(nodesLookup).find(({ id })=>{
            const { startDateVerified, dueDateVerified } = getNode(id);
            return !startDateVerified || !dueDateVerified;
        });
    };
    const updateVerifiedDependencies = (id, dependencyId)=>{
        const node = nodesLookup[id];
        nodesLookup[id] = {
            ...node,
            dependenciesVerified: [
                ...node.dependenciesVerified || [],
                dependencyId
            ]
        };
    };
    const isAllDependenciesVerified = (id)=>{
        const { dependentOn, dependenciesVerified } = getNode(id);
        return dependentOn === null || dependentOn === void 0 ? void 0 : dependentOn.every((dependent)=>dependenciesVerified === null || dependenciesVerified === void 0 ? void 0 : dependenciesVerified.includes(dependent.id));
    };
    const getAllChildNodes = (id)=>{
        const { children } = getNode(id);
        return children && children.length > 0 ? [
            ...children,
            ...children.reduce((result, childId)=>{
                result.push(...getAllChildNodes(childId));
                return result;
            }, [])
        ] : [];
    };
    const getAllParentNodes = (id)=>{
        const { parent } = getNode(id);
        return parent ? [
            parent,
            ...getAllParentNodes(parent)
        ] : [];
    };
    const getTreeNodes = (id)=>{
        return [
            id,
            ...getAllChildNodes(id),
            ...getAllParentNodes(id)
        ];
    };
    const isTreeDependentOn = (tree1, tree2, // memo per call: the dependency DAG shares ancestors, unmemoized recursion is exponential
    visited = new Set())=>{
        const _tree1 = tree1.filter((nodeId)=>!tree2.includes(nodeId));
        const _tree2 = tree2.filter((nodeId)=>!tree1.includes(nodeId));
        for(let index = 0; index < _tree1.length; index += 1){
            const { dependentOn } = getNode(_tree1[index]);
            /**
       * If in case dependencies happen to be in the same tree,
       * avoiding such nodes during processing.
       */ const validDependentOn = dependentOn ? dependentOn === null || dependentOn === void 0 ? void 0 : dependentOn.filter((_dep)=>!_tree1.includes(_dep.id)) : [];
            if (validDependentOn === null || validDependentOn === void 0 ? void 0 : validDependentOn.find((_dep)=>_tree2.includes(_dep.id))) {
                return true;
            }
            const dependencies = validDependentOn || [];
            for(let _index = 0; _index < (dependencies === null || dependencies === void 0 ? void 0 : dependencies.length); _index += 1){
                const visitKey = `${dependencies[_index].id}|${_tree2.join(',')}`;
                if (visited.has(visitKey)) {
                    continue;
                }
                visited.add(visitKey);
                const tree = getTreeNodes(dependencies[_index].id);
                if (isTreeDependentOn(tree, _tree2, visited)) {
                    return true;
                }
            }
        }
        return false;
    };
    const removeInvalidDependencies = ()=>{
        const dependentTasks = Object.values(tasks).filter(({ dependentOn })=>dependentOn && dependentOn.length > 0);
        dependentTasks.forEach((_task)=>{
            var _node_dependentOn;
            const node = getNode(_task.id);
            const childNodes = getAllChildNodes(_task.id);
            const parentNodes = getAllParentNodes(_task.id);
            (_node_dependentOn = node.dependentOn) === null || _node_dependentOn === void 0 ? void 0 : _node_dependentOn.forEach((dependent)=>{
                if (childNodes.includes(dependent.id) || parentNodes.includes(dependent.id) || isTreeDependentOn(getTreeNodes(dependent.id), [
                    _task.id,
                    ...childNodes,
                    ...parentNodes
                ])) {
                    var _node_dependentOn, _dependency_dependencyFor;
                    updateNode(_task.id, {
                        dependentOn: (_node_dependentOn = node.dependentOn) === null || _node_dependentOn === void 0 ? void 0 : _node_dependentOn.filter((_d)=>_d.id !== dependent.id)
                    });
                    const dependency = getNode(dependent.id);
                    updateNode(dependent.id, {
                        dependencyFor: (_dependency_dependencyFor = dependency.dependencyFor) === null || _dependency_dependencyFor === void 0 ? void 0 : _dependency_dependencyFor.filter((_t)=>_t.id !== _task.id)
                    });
                }
            });
        });
    };
    const processTree = (rootNodeId, currentDepth)=>{
        const treeNodesByDepth = [];
        const { depth: rootNodeDepth } = getNode(rootNodeId);
        let iDepth = rootNodeDepth;
        (function topDownTraversal(nodeIds) {
            if (nodeIds.length <= 0) {
                return;
            }
            treeNodesByDepth.push({
                depth: iDepth,
                nodes: nodeIds
            });
            iDepth += 1;
            const nodesAtCurrentDepth = [];
            nodeIds.forEach((_id)=>{
                const { startDate: parentStartDate, children } = getNode(_id);
                if (!isAllDependenciesVerified(_id)) {
                    return;
                }
                markStartDateVerified(_id);
                children === null || children === void 0 ? void 0 : children.forEach((childId)=>{
                    const { startDate: childStartDate, dueDate: childDueDate } = getNode(childId);
                    if (moment(childStartDate).isBefore(moment(parentStartDate))) {
                        const duration = getDaysDiff(childDueDate, childStartDate, allowWeekend);
                        updateNode(childId, {
                            startDate: parentStartDate,
                            dueDate: addDays(parentStartDate, duration, allowWeekend).format('YYYY-MM-DD')
                        });
                    }
                });
                nodesAtCurrentDepth.push(...children || []);
            });
            topDownTraversal(nodesAtCurrentDepth);
        })([
            rootNodeId
        ]);
        for(let index = treeNodesByDepth.length - 1; index >= 0; index -= 1){
            const { depth, nodes } = treeNodesByDepth[index];
            if (depth < currentDepth) {
                break;
            }
            nodes.forEach((_id)=>{
                const { id, children, dueDate } = getNode(_id);
                const isChildrenDueDateVerified = !(children === null || children === void 0 ? void 0 : children.find((childId)=>{
                    const child = getNode(childId);
                    return !child.dueDateVerified;
                }));
                if (!isChildrenDueDateVerified) {
                    return;
                }
                const newDueDate = !children || (children === null || children === void 0 ? void 0 : children.length) <= 0 ? dueDate : children === null || children === void 0 ? void 0 : children.reduce((currentDate, childId)=>{
                    const child = getNode(childId);
                    if (!currentDate || moment(child.dueDate).isAfter(moment(currentDate))) {
                        return child.dueDate;
                    }
                    return currentDate;
                }, dueDate);
                if (dueDate !== newDueDate) {
                    updateNode(id, {
                        dueDate: newDueDate
                    });
                }
                markDueDateVerified(id);
                processVerifiedNode(id, currentDepth);
            });
        }
    };
    const processVerifiedNode = (id, currentDepth)=>{
        const { startDate: nodeStartDate, dueDate: nodeDueDate, dependencyFor } = getNode(id);
        dependencyFor === null || dependencyFor === void 0 ? void 0 : dependencyFor.forEach((dependent)=>{
            var _dependent_lag;
            const dependency = getNode(dependent.id);
            const dependencyParent = getNode(dependency.parent);
            const { dependencyType } = dependent;
            const lag = (_dependent_lag = dependent.lag) !== null && _dependent_lag !== void 0 ? _dependent_lag : 0;
            const duration = getDaysDiff(dependency.dueDate, dependency.startDate, allowWeekend);
            let newStartDate = null;
            let newDueDate = null;
            if (dependencyType === DependencyTypesValues.SS) {
                // Start-to-Start: successor.startDate >= predecessor.startDate + lag
                const minStartDate = moment(nodeStartDate).add(lag, 'days');
                if (moment(dependency.startDate).isBefore(minStartDate)) {
                    newStartDate = minStartDate.format('YYYY-MM-DD');
                    newDueDate = addDays(newStartDate, duration, allowWeekend).format('YYYY-MM-DD');
                }
            } else if (dependencyType === DependencyTypesValues.SF) {
                // Start-to-Finish: successor.dueDate >= predecessor.startDate + lag
                const minDueDate = moment(nodeStartDate).add(lag, 'days');
                if (moment(dependency.dueDate).isBefore(minDueDate)) {
                    newDueDate = minDueDate.format('YYYY-MM-DD');
                    newStartDate = moment(newDueDate).subtract(duration, 'days').format('YYYY-MM-DD');
                }
            } else if (dependencyType === DependencyTypesValues.FF) {
                // Finish-to-Finish: successor.dueDate >= predecessor.dueDate + lag
                const minDueDate = moment(nodeDueDate).add(lag, 'days');
                if (moment(dependency.dueDate).isBefore(minDueDate)) {
                    newDueDate = minDueDate.format('YYYY-MM-DD');
                    newStartDate = moment(newDueDate).subtract(duration, 'days').format('YYYY-MM-DD');
                }
            } else {
                // FS (Finish-to-Start) or default: successor.startDate >= predecessor.dueDate + lag + 1
                const minStartDate = moment(nodeDueDate).add(lag + 1, 'days');
                if (moment(dependency.startDate).isBefore(minStartDate)) {
                    newStartDate = minStartDate.format('YYYY-MM-DD');
                    newDueDate = addDays(newStartDate, duration, allowWeekend).format('YYYY-MM-DD');
                }
            }
            if (newStartDate && newDueDate) {
                updateNode(dependent.id, {
                    startDate: newStartDate,
                    dueDate: newDueDate
                });
            }
            updateVerifiedDependencies(dependent.id, id);
            if (!dependencyParent.startDateVerified || !isAllDependenciesVerified(dependent.id)) {
                return;
            }
            markStartDateVerified(dependent.id);
            processTree(dependent.id, currentDepth);
        });
    };
    /**
   * Step 1: Remove invalid dependencies
   */ removeInvalidDependencies();
    /**
   * Step 2: Top down tree traversal for start date verification
   */ const treeDepth = function processIndependentNodes(currentDepth) {
        const nodesAtCurrentDepth = Object.values(nodesLookup).filter(({ depth })=>depth === currentDepth).map(({ id })=>id);
        if (nodesAtCurrentDepth.length <= 0) {
            return currentDepth;
        }
        const independentNodes = nodesAtCurrentDepth.filter((id)=>{
            const { dependentOn } = getNode(id);
            return isEmpty(dependentOn);
        });
        independentNodes.forEach((id)=>{
            const { children, startDate: parentStartDate, parent } = getNode(id);
            const parentNode = getNode(parent);
            if (!isEmpty(parentNode) && !parentNode.startDateVerified) {
                return;
            }
            markStartDateVerified(id);
            children === null || children === void 0 ? void 0 : children.forEach((childId)=>{
                const { startDate: childStartDate, dueDate: childDueDate } = getNode(childId);
                if (moment(childStartDate).isBefore(moment(parentStartDate))) {
                    const duration = getDaysDiff(childDueDate, childStartDate, allowWeekend);
                    updateNode(childId, {
                        startDate: parentStartDate,
                        dueDate: addDays(parentStartDate, duration, allowWeekend).format('YYYY-MM-DD')
                    });
                }
            });
        });
        return processIndependentNodes(currentDepth + 1);
    }(0);
    /**
   * Step 3: Bottom up tree traversal for due date and dependency verification
   */ for(let currentDepth = treeDepth - 1; currentDepth >= 0; currentDepth -= 1){
        const nodesAtCurrentDepth = Object.values(nodesLookup).filter(({ depth })=>depth === currentDepth).map(({ id })=>id);
        const startDateVerifiedNodes = nodesAtCurrentDepth.filter((id)=>{
            const { startDateVerified } = getNode(id);
            return startDateVerified;
        });
        startDateVerifiedNodes.forEach((id)=>{
            const { children, dueDate, type } = getNode(id);
            const isChildrenDueDateVerified = !(children === null || children === void 0 ? void 0 : children.find((childId)=>{
                const child = getNode(childId);
                return !child.dueDateVerified;
            }));
            if (!isChildrenDueDateVerified) {
                return;
            }
            const newDueDate = !children || (children === null || children === void 0 ? void 0 : children.length) <= 0 ? dueDate : children === null || children === void 0 ? void 0 : children.reduce((currentDate, childId)=>{
                const child = getNode(childId);
                if (!currentDate || moment(child.dueDate).isAfter(moment(currentDate))) {
                    return child.dueDate;
                }
                return currentDate;
            }, null);
            if (dueDate !== newDueDate) {
                /**
         * Phase should always be having the earliest start date and latest due date of its children
         * It need not be the case for a parent task where its due date can be latest than due date of its children.
         * The above assertion is based on the product call taken.
         */ if (type !== 1 || moment(dueDate).isBefore(moment(newDueDate))) {
                    updateNode(id, {
                        dueDate: newDueDate
                    });
                }
            }
            markDueDateVerified(id);
            processVerifiedNode(id, currentDepth);
        });
    }
    if (!isAllNodesVerified()) {
    // logger.warn(
    //   'Date shift: Auto correction: There are nodes pending for verification.',
    // );
    }
    const phaseUpdates = {};
    const taskUpdates = {};
    Object.values(updates).forEach(({ type, dependencyFor, ...rest })=>{
        if (type === 0) {
            phaseUpdates[rest.id] = rest;
        } else if (type === 1) {
            taskUpdates[rest.id] = rest;
        }
    });
    return [
        phaseUpdates,
        taskUpdates
    ];
};
export const doesEntityAffectOtherEntities = (entity, taskUpdates, phaseUpdates, sprintUpdates, taskList, sprintList, phaseList)=>{
    const { id } = entity;
    let sortedPhaseUpdates = [];
    let sortedTaskUpdates = [];
    const _phaseUpdates = {};
    switch(entity.type){
        case 0:
            sortedPhaseUpdates = Object.values(phaseUpdates).filter((phase)=>phase.id !== id).sort((a, b)=>a.id - b.id);
            break;
        case 1:
            sortedTaskUpdates = Object.values(taskUpdates).filter((task)=>task.id !== id).sort((a, b)=>a.id - b.id);
            sortedPhaseUpdates = Object.values(phaseUpdates).filter((phase)=>phase.id !== taskList[id].projectPhaseId).sort((a, b)=>a.id - b.id);
            break;
        case 2:
            sortedTaskUpdates = Object.values(sprintUpdates).filter((sprint)=>sprint.id !== id).sort((a, b)=>a.id - b.id);
            sortedPhaseUpdates = Object.values(phaseUpdates).filter((phase)=>phase.id !== sprintList[id].projectPhaseId).sort((a, b)=>a.id - b.id);
            break;
        default:
            break;
    }
    let counter = 0;
    let doesAffectOtherEntities = false;
    if (sortedPhaseUpdates.length > 0) {
        sortedPhaseUpdates.forEach((phase)=>{
            const { id: phaseId, startDate: newStartDate, dueDate: newDueDate } = phase;
            const { startDate, dueDate } = phaseList[phaseId];
            if (newStartDate && startDate && !moment(newStartDate).isSame(moment(startDate)) || newDueDate && dueDate && !moment(newDueDate).isSame(moment(dueDate))) {
                doesAffectOtherEntities = true;
            }
        });
        if (doesAffectOtherEntities) {
            return {
                phaseUpdates: {},
                doesAffectOtherEntities: true
            };
        }
    }
    sortedTaskUpdates.forEach((task)=>{
        if (task.id === id || doesAffectOtherEntities || counter > SAME_PHASE_TASKS_MOVED_MAX_LIMIT) {
            return;
        }
        const { projectPhaseId } = taskList[task.id];
        if (projectPhaseId === taskList[entity.id].projectPhaseId) {
            counter += 1;
        } else {
            doesAffectOtherEntities = true;
        }
    });
    if (counter > SAME_PHASE_TASKS_MOVED_MAX_LIMIT && Object.values(phaseUpdates).length <= 0) {
        const { projectPhaseId } = taskList[entity.id];
        if (projectPhaseId) {
            const phase = phaseList[projectPhaseId];
            if (phase.id) {
                _phaseUpdates[phase.id] = {
                    id: phase.id,
                    startDate: phase.startDate,
                    dueDate: phase.dueDate
                };
            }
        }
    }
    if (doesAffectOtherEntities && Object.values(phaseUpdates).length <= 0) {
        Object.values(taskUpdates).forEach((task)=>{
            const { projectPhaseId } = taskList[task.id];
            if (projectPhaseId) {
                const phase = phaseList[projectPhaseId];
                if (phase.id) {
                    _phaseUpdates[phase.id] = {
                        id: phase.id,
                        startDate: phase.startDate,
                        dueDate: phase.dueDate
                    };
                }
            }
        });
    }
    return {
        phaseUpdates: _phaseUpdates,
        doesAffectOtherEntities: doesAffectOtherEntities || counter > SAME_PHASE_TASKS_MOVED_MAX_LIMIT
    };
};
/*
Dear programmer,
when i took charge of date shift feature, i thought it was a simple task. But i was wrong.
I wrote new chunks of code, i refactored existing code, i wrote new tests, i fixed bugs, i wrote more tests, i fixed more bugs.

When i wrote the new code, only God and I understood what i was doing. Now, only God knows.

May God be with you.


PS. You will find that the execution starts from the bottom of the function. So scroll through everthing to get the context.
Another PS: After revisiting this, I have totally forgotten what is happening here. So, Plz dont bitch about the me.
*/ export const getDateShiftsForEntity = (phases, tasks, sprints, entity, options)=>{
    var _ref, _ref1;
    let updates = {
        [entity.id]: {
            ...entity
        }
    };
    const updatesWithConflictingDates = {};
    const dependencyRelationsToDelete = [];
    const nodesLookup = {
        ...phases,
        ...tasks,
        ...sprints
    };
    const isNewDependenciesEnabled = (_ref = options === null || options === void 0 ? void 0 : options.enabledNewDependencies) !== null && _ref !== void 0 ? _ref : false;
    let allowWeekend = (_ref1 = options === null || options === void 0 ? void 0 : options.allowWeekend) !== null && _ref1 !== void 0 ? _ref1 : false;
    const allowWeekendForEntityTree = allowWeekend || !!entity.startDate && isWeekEnd(entity.startDate) || !!entity.dueDate && isWeekEnd(entity.dueDate);
    const alignParentWithChildren = options === null || options === void 0 ? void 0 : options.alignParentWithChildren;
    const alignPhaseWithTask = options === null || options === void 0 ? void 0 : options.alignPhaseWithTask;
    const phasesToBeProcessed = [];
    const checkParentTaskBoundaries = [];
    const getCurrentNode = (id)=>({
            ...nodesLookup[id]
        });
    const getUpdatedNode = (id)=>({
            ...nodesLookup[id],
            ...updates[id]
        });
    const updateNode = (id, nodeUpdates)=>{
        if (!updates[id] && !nodesLookup[id]) {
            return;
        }
        updates[id] = {
            ...updates[id] || {
                id,
                type: nodesLookup[id].type
            },
            ...nodeUpdates
        };
    };
    const getAllChildNodes = (id)=>{
        const { children } = getUpdatedNode(id);
        return children && children.length > 0 ? [
            ...children,
            ...children.reduce((result, childId)=>{
                result.push(...getAllChildNodes(childId));
                return result;
            }, [])
        ] : [];
    };
    const _addDays = (date, daysCount, _allowWeekend)=>{
        if (_allowWeekend) {
            return moment(date).add(daysCount, 'day').format(API_DATE_FORMAT);
        }
        let newDate = moment(date);
        const direction = daysCount < 0 ? -1 : 1;
        let _daysCount = Math.abs(daysCount);
        if ([
            0,
            6
        ].includes(moment(date).day())) {
            let tempNewDate = moment(newDate);
            while(_daysCount > 0 && [
                0,
                6
            ].includes(tempNewDate.add(direction, 'day').day())){
                tempNewDate = moment(newDate);
                _daysCount -= 1;
                newDate = newDate.add(direction, 'day');
            }
        }
        while(_daysCount > 0){
            const tempNewDate = moment(newDate);
            if (![
                0,
                6
            ].includes(tempNewDate.add(direction, 'day').day())) {
                _daysCount -= 1;
            }
            newDate = newDate.add(direction, 'day');
        }
        return newDate.format(API_DATE_FORMAT);
    };
    const _getCurrentDuration = (id, _startDate, _dueDate)=>{
        if (allowWeekend) {
            return getDaysDiff(_dueDate, _startDate, allowWeekend);
        }
        const childNodes = getAllChildNodes(id);
        const countedWeekends = [];
        const blackListedWeekends = [];
        if (isWeekEnd(_startDate)) {
            if (!blackListedWeekends.includes(_startDate)) {
                blackListedWeekends.push(_startDate, formatDate(moment(_startDate).day() === 6 ? moment(_startDate).add(1, 'day') : moment(_startDate).subtract(1, 'day')));
            }
        }
        if (isWeekEnd(_dueDate)) {
            if (!blackListedWeekends.includes(_dueDate)) {
                blackListedWeekends.push(_dueDate, formatDate(moment(_dueDate).day() === 6 ? moment(_dueDate).add(1, 'day') : moment(_dueDate).subtract(1, 'day')));
            }
        }
        childNodes === null || childNodes === void 0 ? void 0 : childNodes.forEach((childId)=>{
            const { startDate, dueDate } = getUpdatedNode(childId);
            if (isWeekEnd(startDate) && !countedWeekends.includes(startDate) && !blackListedWeekends.includes(startDate)) {
                countedWeekends.push(startDate, formatDate(moment(startDate).day() === 6 ? moment(startDate).add(1, 'day') : moment(startDate).subtract(1, 'day')));
            }
            if (isWeekEnd(dueDate) && !countedWeekends.includes(dueDate) && !blackListedWeekends.includes(dueDate)) {
                countedWeekends.push(dueDate, formatDate(moment(dueDate).day() === 6 ? moment(dueDate).add(1, 'day') : moment(dueDate).subtract(1, 'day')));
            }
        });
        return getDuration(_startDate, _dueDate, allowWeekend) + countedWeekends.length;
    };
    const getDateDiffForEntity = (id)=>{
        const { startDate: newStartDate, dueDate: newDueDate } = getUpdatedNode(id);
        const { startDate, dueDate } = getCurrentNode(id);
        const currentDuration = _getCurrentDuration(id, startDate, dueDate);
        const newDuration = getDuration(newStartDate, newDueDate, allowWeekend);
        return {
            startDate: allowWeekend ? getDateDiff(newStartDate, startDate) : getDaysDiff(newStartDate, startDate),
            dueDate: allowWeekend ? getDateDiff(newDueDate, dueDate) : getDaysDiff(newDueDate, dueDate),
            duration: newDuration - currentDuration
        };
    };
    const getPhaseDates = (id)=>{
        const { startDate, dueDate, children } = getUpdatedNode(id);
        const [_startDate, _dueDate] = (children === null || children === void 0 ? void 0 : children.reduce((result, childId)=>{
            const [currentStartDate, currentDueDate] = result;
            let newStartDate = currentStartDate;
            let newDueDate = currentDueDate;
            const { startDate: childStartDate, dueDate: childDueDate } = getUpdatedNode(childId);
            if (!currentStartDate || childStartDate && moment(childStartDate).isBefore(moment(currentStartDate))) {
                newStartDate = childStartDate;
            }
            if (!currentDueDate || childDueDate && moment(childDueDate).isAfter(moment(currentDueDate))) {
                newDueDate = childDueDate;
            }
            return [
                newStartDate,
                newDueDate
            ];
        }, [])) || [
            moment(startDate).format(API_DATE_FORMAT),
            moment(dueDate).format(API_DATE_FORMAT)
        ];
        return [
            moment(_startDate).format(API_DATE_FORMAT),
            moment(_dueDate).format(API_DATE_FORMAT)
        ];
    };
    const postponeDependenciesFor = (_id)=>{
        const { dueDate: nodeDueDate, dependencyFor, parent } = getUpdatedNode(_id);
        const parentNode = getUpdatedNode(parent);
        dependencyFor === null || dependencyFor === void 0 ? void 0 : dependencyFor.forEach((dependent)=>{
            const { startDate: currentStartDate, dueDate: currentDueDate, parent: parentOfDependency } = getCurrentNode(dependent.id);
            const { startDate } = getUpdatedNode(dependent.id);
            /*
      This block is added to let phase dependency take precedence over the task's dependency.

      This is added after backend changes went live where they check if the parents have dependency,
      if yes, then they will process them instead of processing the task dependency.

      */ if (!parentNode.parent) {
                const parentOfDependencyNode = getUpdatedNode(parentOfDependency);
                if (!parentOfDependencyNode.parent && parentOfDependency) {
                    var _parentNode_dependencyFor;
                    if ((_parentNode_dependencyFor = parentNode.dependencyFor) === null || _parentNode_dependencyFor === void 0 ? void 0 : _parentNode_dependencyFor.some((p)=>p.id === parentOfDependency)) {
                        const _newStartDate = _addDays(parentNode.dueDate, 1, allowWeekend);
                        const { startDate: _currentStartDate, dueDate: _currentDueDate } = getCurrentNode(parentOfDependency);
                        const { startDate: _startDate } = getUpdatedNode(parentOfDependency);
                        const duration = _getCurrentDuration(parentOfDependency, _currentStartDate, _currentDueDate);
                        updateNode(parentOfDependency, {
                            startDate: moment(_newStartDate).format(API_DATE_FORMAT),
                            dueDate: _addDays(_newStartDate, duration - 1, allowWeekend)
                        });
                        const shiftedBy = getDaysDiff(_newStartDate, _startDate);
                        return handleShift(parentOfDependency, shiftedBy);
                    }
                }
            }
            if (moment(startDate).isAfter(nodeDueDate)) {
                return false;
            }
            const newStartDate = _addDays(nodeDueDate, 1, allowWeekend);
            const duration = _getCurrentDuration(dependent.id, currentStartDate, currentDueDate);
            const shiftedBy = getDaysDiff(newStartDate, startDate);
            updateNode(dependent.id, {
                startDate: moment(newStartDate).format(API_DATE_FORMAT),
                dueDate: _addDays(newStartDate, duration - 1, allowWeekend)
            });
            return handleShift(dependent.id, shiftedBy);
        });
    };
    const preponeDependentsOn = (_id)=>{
        const { startDate: nodeStartDate, dependentOn, parent } = getUpdatedNode(_id);
        const parentNode = getUpdatedNode(parent);
        dependentOn === null || dependentOn === void 0 ? void 0 : dependentOn.forEach((dependency)=>{
            const { startDate: currentStartDate, dueDate: currentDueDate, parent: parentOfDependency } = getCurrentNode(dependency.id);
            const { dueDate } = getUpdatedNode(dependency.id);
            /*
      This block is added to let phase dependency take precedence over the task's dependency.

      This is added after backend changes went live where they check if the parents have dependency,
      if yes, then they will process them instead of processing the task dependency.
      */ if (!parentNode.parent) {
                const parentOfDependencyNode = getUpdatedNode(parentOfDependency);
                if (!parentOfDependencyNode.parent && parentOfDependency) {
                    var _parentNode_dependentOn;
                    if ((_parentNode_dependentOn = parentNode.dependentOn) === null || _parentNode_dependentOn === void 0 ? void 0 : _parentNode_dependentOn.some((dep)=>dep.id === parentOfDependency)) {
                        const _newDueDate = _addDays(parentNode.startDate, -1, allowWeekend);
                        const { startDate: _currentStartDate, dueDate: _currentDueDate } = getCurrentNode(parentOfDependency);
                        const { dueDate: _dueDate } = getUpdatedNode(parentOfDependency);
                        const duration = _getCurrentDuration(parentOfDependency, _currentStartDate, _currentDueDate);
                        const newShiftedBy = getDateDiff(_newDueDate, _dueDate);
                        updateNode(parentOfDependency, {
                            startDate: _addDays(_newDueDate, -(duration - 1), allowWeekend),
                            dueDate: _newDueDate
                        });
                        return handleShift(parentOfDependency, newShiftedBy, {
                            processDependentsOn: true
                        });
                    }
                }
            }
            if (moment(dueDate).isBefore(nodeStartDate)) {
                return false;
            }
            const newDueDate = _addDays(nodeStartDate, -1, allowWeekend);
            const duration = _getCurrentDuration(dependency.id, currentStartDate, currentDueDate);
            const newShiftedBy = getDaysDiff(newDueDate, dueDate);
            updateNode(dependency.id, {
                startDate: _addDays(newDueDate, -(duration - 1), allowWeekend),
                dueDate: newDueDate
            });
            return handleShift(dependency.id, newShiftedBy, {
                processDependentsOn: true
            });
        });
    };
    // This works beautifully, so please avoid touching it.
    // Only do so if you have a better understanding of the code.
    // Which u will never have.
    // So GOOD LUCK
    const processAsSuccessor = (_id, checkForConflictingDates = false, dependencyOperationsDone = false)=>{
        const { dueDate: nodeDueDate, dependentOn, startDate: nodeStartDate, projectPhaseId: successorProjectPhaseId } = getUpdatedNode(_id);
        let newStartDate = null;
        let newDueDate = null;
        let newShiftedBy = 0;
        dependentOn === null || dependentOn === void 0 ? void 0 : dependentOn.forEach((dependent)=>{
            let _newStartDate = null;
            let _newDueDate = null;
            const { dependencyType } = dependent;
            let { lag } = dependent;
            if (lag !== null && lag === 0) {
                lag = null;
            }
            const { startDate, dueDate, projectPhaseId: predecessorProjectPhaseId } = getUpdatedNode(dependent.id);
            if (dependencyType === DependencyTypesValues.SS) {
                const diff = allowWeekend ? getDateDiff(nodeStartDate, startDate) : getDaysDiff(nodeStartDate, startDate);
                if (lag !== null && (diff <= 0 || diff > 0 && diff < lag)) {
                    _newStartDate = _addDays(startDate, lag, allowWeekend);
                }
                if (diff < 0 && lag === null) {
                    _newStartDate = startDate;
                }
                if (diff > 0 && (lag !== null && diff > lag || lag === null)) {
                    // _newStartDate = _addDays(startDate, diff, allowWeekend);
                    _newStartDate = nodeStartDate;
                }
                const isWeekend = isWeekEnd(_newStartDate);
                const actualValueOfAllowWeekend = allowWeekend;
                if (isWeekend) {
                    allowWeekend = true;
                }
                const duration = _getCurrentDuration(_id, nodeStartDate, nodeDueDate);
                if (_newStartDate) {
                    _newDueDate = _addDays(_newStartDate, duration - 1, allowWeekend);
                }
                allowWeekend = actualValueOfAllowWeekend;
            }
            if (dependencyType === DependencyTypesValues.SF) {
                const diff = allowWeekend ? getDateDiff(nodeDueDate, startDate) : getDaysDiff(nodeDueDate, startDate);
                if (lag !== null && (diff <= 0 || diff > 0 && diff < lag)) {
                    _newDueDate = _addDays(startDate, lag + 1, allowWeekend);
                }
                if (diff < 0 && lag === null) {
                    _newDueDate = startDate;
                }
                if (diff > 0 && (lag !== null && diff > lag || lag === null)) {
                    _newDueDate = nodeDueDate;
                }
                const isWeekend = isWeekEnd(_newDueDate);
                const actualValueOfAllowWeekend = allowWeekend;
                if (isWeekend) {
                    allowWeekend = true;
                }
                const duration = _getCurrentDuration(_id, nodeStartDate, nodeDueDate);
                if (_newDueDate) {
                    _newStartDate = _addDays(_newDueDate, -(duration - 1), allowWeekend);
                }
                allowWeekend = actualValueOfAllowWeekend;
            }
            if (dependencyType === DependencyTypesValues.FS) {
                const diff = allowWeekend ? getDateDiff(nodeStartDate, dueDate) : getDaysDiff(nodeStartDate, dueDate);
                if (lag !== null && (diff <= 0 || diff > 0 && diff < lag + 1)) {
                    _newStartDate = _addDays(dueDate, lag + 1, allowWeekend);
                }
                if (diff <= 0 && lag === null) {
                    _newStartDate = _addDays(dueDate, 1, allowWeekend);
                }
                if (diff > 0 && (lag !== null && diff > lag + 1 || lag === null)) {
                    _newStartDate = nodeStartDate;
                }
                // if (diff > 0 && allowWeekend) {
                //   _newStartDate = _addDays(dueDate, 1, allowWeekend);
                // }
                const isWeekend = isWeekEnd(_newStartDate);
                const actualValueOfAllowWeekend = allowWeekend;
                if (isWeekend) {
                    allowWeekend = true;
                }
                const duration = _getCurrentDuration(_id, nodeStartDate, nodeDueDate);
                if (_newStartDate) {
                    _newDueDate = _addDays(_newStartDate, duration - 1, allowWeekend);
                }
                allowWeekend = actualValueOfAllowWeekend;
            }
            if (dependencyType === DependencyTypesValues.FF) {
                const diff = allowWeekend ? getDateDiff(nodeDueDate, dueDate) : getDaysDiff(nodeDueDate, dueDate);
                if (lag !== null && (diff <= 0 || diff > 0 && diff < lag)) {
                    _newDueDate = _addDays(dueDate, lag, allowWeekend);
                }
                if (diff < 0 && lag === null) {
                    _newDueDate = dueDate;
                }
                if (diff > 0 && (lag !== null && diff > lag || lag === null)) {
                    _newDueDate = nodeDueDate;
                }
                const isWeekend = isWeekEnd(_newDueDate);
                const actualValueOfAllowWeekend = allowWeekend;
                if (isWeekend) {
                    allowWeekend = true;
                }
                const duration = _getCurrentDuration(_id, nodeStartDate, nodeDueDate);
                if (_newDueDate) {
                    _newStartDate = _addDays(_newDueDate, -(duration - 1), allowWeekend);
                }
                allowWeekend = actualValueOfAllowWeekend;
            }
            if (newStartDate != null && moment(_newStartDate).isAfter(moment(newStartDate)) || newStartDate == null && _newStartDate != null) {
                if (checkForConflictingDates && !moment(_newStartDate).isSame(moment(nodeStartDate))) {
                    if (entity.type === 0 && successorProjectPhaseId && predecessorProjectPhaseId && successorProjectPhaseId === predecessorProjectPhaseId) {
                        return;
                    }
                    dependencyRelationsToDelete.push(`${_id}-${dependent.id}`);
                    return;
                }
                newStartDate = _newStartDate;
                newDueDate = _newDueDate;
                updateNode(_id, {
                    startDate: newStartDate,
                    dueDate: newDueDate
                });
                newShiftedBy = getDaysDiff(newStartDate, startDate);
            }
        });
        const { startDate: afterProcessStartDate } = getUpdatedNode(_id);
        if (!moment(afterProcessStartDate).isSame(moment(newStartDate))) {
            newShiftedBy = getDaysDiff(newStartDate, afterProcessStartDate);
        }
        if (dependencyOperationsDone) {
            return handleShift(_id, newShiftedBy);
        }
        return true;
    };
    const processDependenciesFor = (_id, fromChildrenProcessing = false)=>{
        const { dueDate: nodeDueDate, dependencyFor, parent: parentOfPredecessor, startDate: nodeStartDate, projectPhaseId: nodeProjectPhaseId } = getUpdatedNode(_id);
        const { startDate: currentNodeStartDate, dueDate: currentNodeDueDate } = getCurrentNode(_id);
        let sortedDependencyFor = dependencyFor;
        sortedDependencyFor = dependencyFor ? dependencyFor.map((dependent)=>{
            const { projectPhaseId: dependentProjectPhaseId } = getUpdatedNode(dependent.id);
            return {
                ...dependent,
                dependentProjectPhaseId
            };
        }).sort((a, b)=>{
            if (a.dependentProjectPhaseId === nodeProjectPhaseId) {
                return -1;
            }
            if (b.dependentProjectPhaseId === nodeProjectPhaseId) {
                return 1;
            }
            const { startDate: aStartDate } = getUpdatedNode(a.id);
            const { startDate: bStartDate } = getUpdatedNode(b.id);
            return moment(aStartDate).isBefore(moment(bStartDate)) ? -1 : 1;
        }) : [];
        sortedDependencyFor === null || sortedDependencyFor === void 0 ? void 0 : sortedDependencyFor.forEach((dependent)=>{
            const { dependencyType } = dependent;
            let { lag } = dependent;
            if (lag !== null && lag === 0) {
                lag = null;
            }
            const { startDate, dueDate, parent: parentOfSuccessor } = getUpdatedNode(dependent.id);
            const { startDate: currentStartDate, dueDate: currentDueDate } = getCurrentNode(dependent.id);
            const handler = allowWeekend ? getDateDiff : getDaysDiff;
            let newStartDate = null;
            let newDueDate = null;
            let newShiftedBy = 0;
            let isPreponed = false;
            if (dependencyType === DependencyTypesValues.SS) {
                const diff = handler(currentStartDate, currentNodeStartDate);
                const afterShiftDiff = handler(startDate, nodeStartDate);
                if (afterShiftDiff > 0 && diff < afterShiftDiff) {
                    isPreponed = true;
                    if (lag !== null) {
                        newStartDate = _addDays(nodeStartDate, lag, allowWeekend);
                    } else if (diff >= 0) {
                        newStartDate = _addDays(nodeStartDate, diff, allowWeekend);
                    } else {
                        newStartDate = _addDays(nodeStartDate, afterShiftDiff, allowWeekend);
                    }
                } else if (diff === afterShiftDiff) {
                    newStartDate = startDate;
                } else if (afterShiftDiff > 0 && lag !== null && diff > afterShiftDiff && afterShiftDiff > lag) {
                    newStartDate = startDate;
                } else if (afterShiftDiff >= 0 && lag !== null && diff > afterShiftDiff && afterShiftDiff <= lag) {
                    newStartDate = _addDays(nodeStartDate, lag, allowWeekend);
                } else if (lag === null && afterShiftDiff > 0 && diff > afterShiftDiff) {
                    newStartDate = startDate;
                } else if (afterShiftDiff <= 0 && lag === null) {
                    newStartDate = nodeStartDate;
                } else if (afterShiftDiff < 0 && lag !== null) {
                    newStartDate = _addDays(nodeStartDate, lag, allowWeekend);
                } else if (afterShiftDiff === diff && lag !== null) {
                    newStartDate = _addDays(nodeStartDate, lag, allowWeekend);
                } else {
                    newStartDate = startDate;
                }
                let duration;
                const isWeekend = isWeekEnd(newStartDate);
                const actualValueOfAllowWeekend = allowWeekend;
                if (isWeekend) {
                    allowWeekend = true;
                }
                if (updates[dependent.id] && updates[dependent.id].startDate && updates[dependent.id].dueDate) {
                    duration = _getCurrentDuration(dependent.id, startDate, dueDate);
                } else {
                    duration = _getCurrentDuration(dependent.id, currentStartDate, currentDueDate);
                }
                // const duration = _getCurrentDuration(dependent.id, startDate, dueDate);
                newDueDate = _addDays(newStartDate, duration - 1, allowWeekend);
                allowWeekend = actualValueOfAllowWeekend;
            }
            if (dependencyType === DependencyTypesValues.SF) {
                const diff = handler(currentDueDate, currentNodeStartDate);
                const afterShiftDiff = handler(dueDate, nodeStartDate);
                if (afterShiftDiff > 0 && diff < afterShiftDiff) {
                    isPreponed = true;
                    if (lag !== null) {
                        newDueDate = _addDays(nodeStartDate, lag + 1, allowWeekend);
                    } else if (diff >= 0) {
                        newDueDate = _addDays(nodeStartDate, diff, allowWeekend);
                    } else {
                        newDueDate = _addDays(nodeStartDate, afterShiftDiff, allowWeekend);
                    }
                } else if (diff === afterShiftDiff) {
                    newDueDate = dueDate;
                } else if (afterShiftDiff > 0 && lag !== null && diff > afterShiftDiff && afterShiftDiff > lag) {
                    newDueDate = dueDate;
                } else if (afterShiftDiff >= 0 && lag !== null && diff > afterShiftDiff && afterShiftDiff <= lag) {
                    newDueDate = _addDays(nodeStartDate, lag + 1, allowWeekend);
                } else if (lag === null && afterShiftDiff > 0 && diff > afterShiftDiff) {
                    newDueDate = dueDate;
                } else if (afterShiftDiff <= 0 && lag === null) {
                    newDueDate = nodeStartDate;
                } else if (afterShiftDiff < 0 && lag !== null) {
                    newDueDate = _addDays(nodeStartDate, lag + 1, allowWeekend);
                } else if (afterShiftDiff === diff && lag !== null) {
                    newDueDate = _addDays(nodeStartDate, lag + 1, allowWeekend);
                } else {
                    newDueDate = dueDate;
                }
                let duration;
                const isWeekend = isWeekEnd(newDueDate);
                const actualValueOfAllowWeekend = allowWeekend;
                if (isWeekend) {
                    allowWeekend = true;
                }
                if (updates[dependent.id] && updates[dependent.id].startDate && updates[dependent.id].dueDate) {
                    duration = _getCurrentDuration(dependent.id, startDate, dueDate);
                } else {
                    duration = _getCurrentDuration(dependent.id, currentStartDate, currentDueDate);
                }
                // const duration = _getCurrentDuration(dependent.id, startDate, dueDate);
                newStartDate = _addDays(newDueDate, -(duration - 1), allowWeekend);
                allowWeekend = actualValueOfAllowWeekend;
            }
            if (dependencyType === DependencyTypesValues.FS) {
                const diff = handler(currentStartDate, currentNodeDueDate);
                const afterShiftDiff = handler(startDate, nodeDueDate);
                if (afterShiftDiff > 0 && diff < afterShiftDiff) {
                    isPreponed = true;
                    if (lag !== null) {
                        newStartDate = _addDays(nodeDueDate, lag + 1, allowWeekend);
                    } else if (diff >= 0) {
                        newStartDate = _addDays(nodeDueDate, diff, allowWeekend);
                    } else {
                        newStartDate = _addDays(nodeDueDate, afterShiftDiff, allowWeekend);
                    }
                } else if (diff === afterShiftDiff) {
                    newStartDate = startDate;
                } else if (afterShiftDiff > 0 && lag !== null && diff > afterShiftDiff && afterShiftDiff > lag + 1) {
                    newStartDate = startDate;
                } else if (afterShiftDiff >= 0 && lag !== null && diff > afterShiftDiff && afterShiftDiff <= lag + 1) {
                    newStartDate = _addDays(nodeDueDate, lag + 1, allowWeekend);
                } else if (lag === null && afterShiftDiff > 0 && diff > afterShiftDiff) {
                    newStartDate = startDate;
                } else if (afterShiftDiff <= 0 && lag === null) {
                    newStartDate = _addDays(nodeDueDate, 1, allowWeekend);
                } else if (afterShiftDiff < 0 && lag !== null) {
                    newStartDate = _addDays(nodeDueDate, lag + 1, allowWeekend);
                } else {
                    newStartDate = startDate;
                }
                let duration;
                const isWeekend = isWeekEnd(newStartDate);
                const actualValueOfAllowWeekend = allowWeekend;
                if (isWeekend) {
                    allowWeekend = true;
                }
                if (updates[dependent.id] && updates[dependent.id].startDate && updates[dependent.id].dueDate) {
                    duration = _getCurrentDuration(dependent.id, startDate, dueDate);
                } else {
                    duration = _getCurrentDuration(dependent.id, currentStartDate, currentDueDate);
                }
                // const duration = _getCurrentDuration(dependent.id, startDate, dueDate);
                if (newStartDate) {
                    newDueDate = _addDays(newStartDate, duration - 1, allowWeekend);
                }
                allowWeekend = actualValueOfAllowWeekend;
            }
            if (dependencyType === DependencyTypesValues.FF) {
                const diff = handler(currentDueDate, currentNodeDueDate);
                const afterShiftDiff = handler(dueDate, nodeDueDate);
                if (afterShiftDiff > 0 && diff < afterShiftDiff) {
                    isPreponed = true;
                    if (lag !== null) {
                        newDueDate = _addDays(nodeDueDate, lag, allowWeekend);
                    } else if (diff >= 0) {
                        newDueDate = _addDays(nodeDueDate, diff, allowWeekend);
                    } else {
                        newDueDate = _addDays(nodeDueDate, afterShiftDiff, allowWeekend);
                    }
                } else if (diff === afterShiftDiff) {
                    newDueDate = dueDate;
                } else if (afterShiftDiff > 0 && lag !== null && diff > afterShiftDiff && afterShiftDiff > lag) {
                    newDueDate = dueDate;
                } else if (afterShiftDiff >= 0 && lag !== null && diff > afterShiftDiff && afterShiftDiff <= lag) {
                    newDueDate = _addDays(nodeDueDate, lag, allowWeekend);
                } else if (lag === null && afterShiftDiff > 0 && diff > afterShiftDiff) {
                    newDueDate = dueDate;
                } else if (afterShiftDiff <= 0 && lag === null) {
                    newDueDate = nodeDueDate;
                } else if (afterShiftDiff < 0 && lag !== null) {
                    newDueDate = _addDays(nodeDueDate, lag, allowWeekend);
                } else if (afterShiftDiff === diff && lag !== null) {
                    newDueDate = _addDays(nodeDueDate, lag, allowWeekend);
                } else {
                    newDueDate = dueDate;
                }
                let duration;
                const isWeekend = isWeekEnd(newDueDate);
                const actualValueOfAllowWeekend = allowWeekend;
                if (isWeekend) {
                    allowWeekend = true;
                }
                if (updates[dependent.id] && updates[dependent.id].startDate && updates[dependent.id].dueDate) {
                    duration = _getCurrentDuration(dependent.id, startDate, dueDate);
                } else {
                    duration = _getCurrentDuration(dependent.id, currentStartDate, currentDueDate);
                }
                // const duration = _getCurrentDuration(dependent.id, startDate, dueDate);
                newStartDate = _addDays(newDueDate, -(duration - 1), allowWeekend);
                allowWeekend = actualValueOfAllowWeekend;
            }
            // The above conditions get a new dates depending on the dependency type.
            // There are many different conditions, at this point even i am not sure what each condition does.
            // But the main idea is to get the new start and due date for the dependent task under different conditions.
            // The below code is needed specially for preponing any entity.
            if (isPreponed && updates[dependent.id] && fromChildrenProcessing && parentOfPredecessor === parentOfSuccessor) {
                newStartDate = startDate;
                newDueDate = dueDate;
            }
            if (newStartDate && newDueDate) {
                updateNode(dependent.id, {
                    startDate: newStartDate,
                    dueDate: newDueDate
                });
                processAsSuccessor(dependent.id, false);
                const { startDate: afterProcessStartDate } = getUpdatedNode(dependent.id);
                newShiftedBy = getDaysDiff(afterProcessStartDate, startDate);
                if (isPreponed && parentOfPredecessor) {
                    const parentIds = getParentNodeIds(_id, nodesLookup);
                    const parentIdsOfDependent = getParentNodeIds(dependent.id, nodesLookup).reverse();
                    if (parentIdsOfDependent.length > 0) {
                        const { startDate: _startDate, dueDate: _dueDate } = getUpdatedNode(dependent.id);
                        const parentWithTheHighestLagInDependency = {
                            id: -1,
                            dependencyType: -1,
                            lag: null
                        };
                        parentIdsOfDependent.forEach((parentId)=>{
                            const parent = nodesLookup[parentId];
                            if (parent) {
                                const { id: _parentId } = parent;
                                const parentNode = getUpdatedNode(_parentId);
                                const dependencies = parentNode.dependentOn;
                                dependencies === null || dependencies === void 0 ? void 0 : dependencies.forEach((d)=>{
                                    // if (parentIds.some((p) => p === d.id)) {
                                    //   if (
                                    //     parentWithTheHighestLagInDependency.id === -1 ||
                                    //     (parentWithTheHighestLagInDependency.id !== -1 &&
                                    //       parentWithTheHighestLagInDependency.lag === null &&
                                    //       d.lag !== null) ||
                                    //     (parentWithTheHighestLagInDependency.lag &&
                                    //       d.lag &&
                                    //       parentWithTheHighestLagInDependency.lag < d.lag)
                                    //   ) {
                                    //     parentWithTheHighestLagInDependency.id = _parentId;
                                    //     parentWithTheHighestLagInDependency.dependencyType =
                                    //       d.dependencyType;
                                    //     parentWithTheHighestLagInDependency.lag = d.lag;
                                    //   }
                                    // }
                                    if (parentWithTheHighestLagInDependency.id === -1 || parentWithTheHighestLagInDependency.id !== -1 && parentWithTheHighestLagInDependency.lag === null && d.lag !== null || parentWithTheHighestLagInDependency.lag && d.lag && parentWithTheHighestLagInDependency.lag < d.lag) {
                                        parentWithTheHighestLagInDependency.id = _parentId;
                                        parentWithTheHighestLagInDependency.dependencyType = d.dependencyType;
                                        parentWithTheHighestLagInDependency.lag = d.lag;
                                    }
                                });
                            }
                        });
                        if (parentWithTheHighestLagInDependency.id !== -1) {
                            const { id } = parentWithTheHighestLagInDependency;
                            const parentNode = getUpdatedNode(id);
                            if (moment(_startDate).isBefore(parentNode.startDate)) {
                                updateNode(id, {
                                    startDate: _startDate
                                });
                                processAsSuccessor(id, false, false);
                                const updatedParentNode = getUpdatedNode(id);
                                if (!moment(updatedParentNode.startDate).isSame(moment(_startDate))) {
                                    updateNode(id, {
                                        startDate: updatedParentNode.startDate,
                                        dueDate: parentNode.dueDate
                                    });
                                    updateNode(dependent.id, {
                                        startDate: updatedParentNode.startDate,
                                        dueDate: _addDays(updatedParentNode.startDate, getDaysDiff(_dueDate, _startDate))
                                    });
                                    // update all the parent tasks of the dependent
                                    parentIdsOfDependent.forEach((_pId)=>{
                                        const parent = nodesLookup[_pId];
                                        if (!phases[parent.id] && moment(parent.startDate).isAfter(updatedParentNode.startDate)) {
                                            updateNode(_pId, {
                                                startDate: updatedParentNode.startDate
                                            });
                                        }
                                    });
                                    newShiftedBy = getDaysDiff(updatedParentNode.startDate, _startDate);
                                } else {
                                    //  this block is interesting, the subtask will extend the start date, we will extend the startdate of the parent, and try to maintain the duration.
                                    //  but if there is another dep to the parent which will correct it and change the duedate, it will end up in some other date.
                                    //  solution is, the start date comes from above, we will process the parent as successor, get the new dates and then set the due date with the new rocketdate due date.
                                    const { dependentOn } = updatedParentNode;
                                    const currentParentNode = getCurrentNode(id);
                                    const parentStartDate = updatedParentNode.startDate;
                                    const parentDueDate = _addDays(updatedParentNode.startDate, getDaysDiff(currentParentNode.dueDate, currentParentNode.startDate));
                                    if (dependentOn && dependentOn.some((d)=>d.id === _id)) {
                                        updateNode(id, {
                                            startDate: parentStartDate,
                                            dueDate: parentDueDate
                                        });
                                        processAsSuccessor(id, false, false);
                                        const afterProcessParentNode = getUpdatedNode(id);
                                        if (!moment(afterProcessParentNode.dueDate).isSame(parentDueDate)) {
                                            updateNode(id, {
                                                startDate: parentStartDate,
                                                dueDate: afterProcessParentNode.dueDate
                                            });
                                        } else {
                                            updateNode(id, {
                                                startDate: parentStartDate,
                                                dueDate: parentDueDate
                                            });
                                        }
                                        if (updatedParentNode.projectPhaseId) {
                                            phasesToBeProcessed.push(updatedParentNode.projectPhaseId);
                                        }
                                    }
                                }
                                // need to check phase boundaries
                                if (!phases[id] && parentIds[parentIds.length - 1] !== parentIdsOfDependent[0] && phases[parentIds[parentIds.length - 1]] && phases[parentIdsOfDependent[0]]) {
                                    const updatePhaseNodeOfDependent = getUpdatedNode(parentIdsOfDependent[0]);
                                    if (moment(updatedParentNode.startDate).isBefore(updatePhaseNodeOfDependent.startDate)) {
                                        updateNode(updatePhaseNodeOfDependent.id, {
                                            startDate: updatedParentNode.startDate
                                        });
                                        processAsSuccessor(updatePhaseNodeOfDependent.id, false);
                                        const afteProcessPhaseNodeOfDependent = getUpdatedNode(parentIdsOfDependent[0]);
                                        if (!moment(afteProcessPhaseNodeOfDependent.startDate).isSame(moment(updatePhaseNodeOfDependent.startDate))) {
                                            updateNode(updatePhaseNodeOfDependent.id, {
                                                startDate: afteProcessPhaseNodeOfDependent.startDate,
                                                dueDate: updatePhaseNodeOfDependent.dueDate
                                            });
                                            // update all the parent tasks of the dependent
                                            parentIdsOfDependent.forEach((_pId)=>{
                                                if (updates[_pId]) {
                                                    updateNode(_pId, {
                                                        startDate: afteProcessPhaseNodeOfDependent.startDate
                                                    });
                                                }
                                            });
                                            updateNode(dependent.id, {
                                                startDate: afteProcessPhaseNodeOfDependent.startDate,
                                                dueDate: _addDays(afteProcessPhaseNodeOfDependent.startDate, getDaysDiff(_dueDate, _startDate))
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (newShiftedBy !== 0) {
                    handleShift(dependent.id, newShiftedBy);
                }
            }
        });
    };
    const getPhaseUpdates = (_phaseId)=>{
        const [newStartDate, newDueDate] = getPhaseDates(_phaseId);
        const parentNode = getUpdatedNode(_phaseId);
        const _updates = {};
        if (!moment(parentNode.startDate).isSame(newStartDate)) {
            _updates.startDate = moment(newStartDate).format(API_DATE_FORMAT);
        }
        if (!moment(parentNode.dueDate).isSame(newDueDate)) {
            _updates.dueDate = moment(newDueDate).format(API_DATE_FORMAT);
        }
        return _updates;
    };
    function processChildren(_id, _allowWeekend, processDependentsOn, shiftedBy, checkForConflictingDates = false) {
        var _children_map;
        const { startDate: currentStartDate } = getCurrentNode(_id);
        const { startDate: newStartDate, children, dueDate: newDueDate } = getUpdatedNode(_id);
        const sortedChildNodes = children === null || children === void 0 ? void 0 : (_children_map = children.map(getCurrentNode)) === null || _children_map === void 0 ? void 0 : _children_map.sort((a, b)=>{
            return moment(a.startDate).diff(moment(b.startDate));
        });
        let lastPosition = 0;
        const childrenToBeProcessed = [];
        sortedChildNodes === null || sortedChildNodes === void 0 ? void 0 : sortedChildNodes.forEach((child, index)=>{
            const handler = allowWeekend ? getDateDiff : getDaysDiff;
            const position = handler(child.startDate, index > 0 ? sortedChildNodes[index - 1].startDate : currentStartDate) + lastPosition;
            lastPosition = position;
            let newChildStartDate = _addDays(newStartDate, position, _allowWeekend);
            const checkIfCurrentWeekendIsAllowed = moment(newChildStartDate).format('dddd') === 'Saturday' && moment(newStartDate).format('dddd') === 'Saturday' && formatDate(newChildStartDate) === newStartDate || moment(newStartDate).format('dddd') === 'Saturday' && moment(newStartDate).add(1, 'day').isSame(moment(newChildStartDate), 'day') || allowWeekend;
            if (!checkIfCurrentWeekendIsAllowed) {
                newChildStartDate = _addDays(newStartDate, position, allowWeekend);
            }
            if (moment(newChildStartDate).isSame(moment(child.startDate)) && getUpdatedNode(child.id).startDate != null && moment(newChildStartDate).isSame(moment(getUpdatedNode(child.id).startDate))) {
                return;
            }
            const duration = _getCurrentDuration(child.id, child.startDate, child.dueDate);
            let newChildDueDate = _addDays(newChildStartDate, duration - 1, allowWeekend);
            /**
       * Defensive check to keep child within parent boundaries
       */ const { startDate: parentStartDate, dueDate: parentDueDate } = getUpdatedNode(child.parent);
            if (moment(newChildStartDate).isBefore(parentStartDate)) {
                newChildStartDate = moment(parentStartDate).format(API_DATE_FORMAT);
                newChildDueDate = _addDays(newChildStartDate, duration - 1, allowWeekend);
                if (moment(newChildDueDate).isAfter(moment(parentDueDate))) {
                    newChildDueDate = moment(parentDueDate).format(API_DATE_FORMAT);
                }
            } else if (moment(newChildDueDate).isAfter(parentDueDate)) {
                newChildDueDate = moment(parentDueDate).format(API_DATE_FORMAT);
                newChildStartDate = _addDays(newChildDueDate, -(duration - 1), allowWeekend);
                if (moment(newChildStartDate).isBefore(moment(parentStartDate))) {
                    newChildStartDate = moment(parentStartDate).format(API_DATE_FORMAT);
                }
            }
            updateNode(child.id, {
                startDate: newChildStartDate,
                dueDate: newChildDueDate
            });
            if (checkForConflictingDates) {
                updatesWithConflictingDates[child.id] = {
                    ...updatesWithConflictingDates[child.id],
                    ...getUpdatedNode(child.id)
                };
            }
            childrenToBeProcessed.push(child.id);
        });
        if (isNewDependenciesEnabled) {
            sortedChildNodes === null || sortedChildNodes === void 0 ? void 0 : sortedChildNodes.forEach((child)=>{
                const { id: childId } = child;
                const updatedChild = getUpdatedNode(childId);
                const { dependentOn, dependencyFor } = updatedChild;
                if (dependentOn && dependentOn.length > 0) {
                    processAsSuccessor(childId, checkForConflictingDates);
                }
                if (dependencyFor && dependencyFor.length > 0) {
                    processDependenciesFor(childId, true);
                }
                const _updatedChild = getUpdatedNode(childId);
                // // //  when can this happen partha....think!
                // if (moment(_updatedChild.startDate).isBefore(newStartDate)) {
                //   updateNode(_id, {
                //     startDate: _updatedChild.startDate,
                //     dueDate: addDays(
                //       _updatedChild.startDate,
                //       getDaysDiff(newDueDate, newStartDate),
                //     ),
                //   });
                // }
                if (moment(_updatedChild.dueDate).isAfter(newDueDate)) {
                    if (!checkParentTaskBoundaries.some((cId)=>cId === childId)) {
                        checkParentTaskBoundaries.push(childId);
                    }
                } else if (checkParentTaskBoundaries.some((cId)=>cId === childId)) {
                    checkParentTaskBoundaries.filter((cId)=>cId !== childId);
                }
            });
        }
        // if (
        //   (!moment(newDueDate).isSame(getUpdatedNode(_id).dueDate) ||
        //     !moment(newStartDate).isSame(getUpdatedNode(_id).startDate)) &&
        //   isNewDependenciesEnabled
        // ) {
        //   processAsSuccessor(_id, false);
        //   processDependenciesFor(_id, false);
        // }
        /**
     * Process node's dependencies
     */ // this logic will kick in when the feature is not turned on
        if (!isNewDependenciesEnabled) {
            sortedChildNodes === null || sortedChildNodes === void 0 ? void 0 : sortedChildNodes.forEach((child)=>{
                const { startDate: _newStartDate } = getUpdatedNode(child.id);
                const _shiftedBy = allowWeekend ? getDateDiff(_newStartDate, child.startDate) : getDaysDiff(_newStartDate, child.startDate);
                if (_shiftedBy > 0) {
                    postponeDependenciesFor(child.id);
                } else if (shiftedBy < 0) {
                    if (processDependentsOn) {
                        preponeDependentsOn(child.id);
                    }
                }
            });
        }
        /** Process node's children */ childrenToBeProcessed.forEach((child)=>{
            processChildren(child, _allowWeekend, processDependentsOn, shiftedBy);
        });
    }
    function checkParentDuringShifting(_id, shiftedBy) {
        const { parent, startDate, dueDate } = getUpdatedNode(_id);
        if (!parent) {
            return [];
        }
        const parentNode = getUpdatedNode(parent);
        const isPhase = !parentNode.parent;
        let _updates = {};
        if (alignParentWithChildren || alignPhaseWithTask) {
            if (isPhase) {
                _updates = getPhaseUpdates(parent);
                phasesToBeProcessed.push(parent);
            } else if (alignParentWithChildren) {
                const [newStartDate, newDueDate] = getPhaseDates(parent);
                if (!moment(parentNode.startDate).isSame(newStartDate)) {
                    _updates.startDate = moment(newStartDate).format(API_DATE_FORMAT);
                }
                if (!moment(parentNode.dueDate).isSame(newDueDate)) {
                    _updates.dueDate = moment(newDueDate).format(API_DATE_FORMAT);
                }
            } else {
                if (shiftedBy > 0 && moment(parentNode.dueDate).isBefore(moment(dueDate))) {
                    _updates.dueDate = dueDate;
                }
                if (shiftedBy < 0 && moment(parentNode.startDate).isAfter(moment(startDate))) {
                    _updates.startDate = startDate;
                }
            }
        } else {
            if (shiftedBy > 0 && moment(parentNode.dueDate).isBefore(moment(dueDate))) {
                _updates.dueDate = dueDate;
            }
            if (shiftedBy < 0 && moment(parentNode.startDate).isAfter(moment(startDate))) {
                _updates.startDate = startDate;
            }
        }
        if (!isEmpty(_updates)) {
            updateNode(parent, _updates);
            return [
                parent,
                ...checkParentDuringShifting(parent, shiftedBy)
            ];
        }
        if (parentNode.dependencyFor && parentNode.dependencyFor.length > 0 && (options === null || options === void 0 ? void 0 : options.enabledNewDependencies)) {
            updateNode(parent, _updates);
            return [
                parent,
                ...checkParentDuringShifting(parent, shiftedBy)
            ];
        }
        return [];
    }
    const handleShift = (id, shiftedBy, _options)=>{
        const processDependentsOn = !_options || _options.processDependentsOn;
        const _allowWeekend = id === entity.id ? allowWeekendForEntityTree : allowWeekend;
        if (!(options === null || options === void 0 ? void 0 : options.enabledNewDependencies)) {
            processChildren(id, _allowWeekend, processDependentsOn, shiftedBy);
        }
        const parentIds = checkParentDuringShifting(id, shiftedBy);
        /**
     * Process dependencies
     */ // const updatedNodes = isNewDependenciesEnabled
        //   ? [id, ...parentIds] // why? -> this makes sure that the max lag rule is being followed throughtout the heirarchy and if the child is preponed beyond a limit and cause the rule to break for the parent. then the next processing of parentIds will fix that
        //   : [...parentIds, id];
        const updatedNodes = [
            ...parentIds,
            id
        ];
        if (isNewDependenciesEnabled) {
            if (_options === null || _options === void 0 ? void 0 : _options.dependencyOperationsDone) {
                processAsSuccessor(id, false, _options === null || _options === void 0 ? void 0 : _options.dependencyOperationsDone);
            }
            updatedNodes.forEach((nodeId)=>{
                // ignore phase processing here, it will get processed at the end
                if (!getUpdatedNode(nodeId).parent && entity.type === 1 && shiftedBy < 0) {
                    phasesToBeProcessed.push(nodeId);
                    return;
                }
                processDependenciesFor(nodeId, false);
            });
        } else if (shiftedBy >= 0) {
            updatedNodes.forEach(postponeDependenciesFor);
        } else if (shiftedBy < 0) {
            updatedNodes.forEach((_id)=>{
                // if (processDependenciesFor) {
                //   preponeDependenciesFor(_id, shiftedBy, updatedNodes);
                // }
                if (processDependentsOn) {
                    // preponeDependentsOn(_id, shiftedBy, updatedNodes);
                    preponeDependentsOn(_id);
                }
            });
        }
        if (options === null || options === void 0 ? void 0 : options.enabledNewDependencies) {
            processChildren(id, _allowWeekend, processDependentsOn, shiftedBy);
        }
    };
    const handleResize = (id, diff)=>{
        const { startDate: startDiff, dueDate: endDiff } = diff;
        const { startDate: nodeStartDate, dueDate: nodeDueDate } = getUpdatedNode(id);
        const handleStartDatePrepone = ()=>{
            // Check Parent
            const parentIds = function checkParent(_id) {
                const { parent, startDate } = getUpdatedNode(_id);
                if (!parent) {
                    return [];
                }
                const parentNode = getUpdatedNode(parent);
                const isPhase = !parentNode.parent;
                let _updates = {};
                if (alignParentWithChildren || alignPhaseWithTask) {
                    if (isPhase) {
                        _updates = getPhaseUpdates(parent);
                        phasesToBeProcessed.push(parent);
                    } else if (alignParentWithChildren) {
                        const [newStartDate, newDueDate] = getPhaseDates(parent);
                        if (!moment(parentNode.startDate).isSame(newStartDate)) {
                            _updates.startDate = moment(newStartDate).format(API_DATE_FORMAT);
                        }
                        if (!moment(parentNode.dueDate).isSame(newDueDate)) {
                            _updates.dueDate = moment(newDueDate).format(API_DATE_FORMAT);
                        }
                    } else if (moment(parentNode.startDate).isAfter(moment(startDate))) {
                        _updates.startDate = startDate;
                    }
                } else if (moment(parentNode.startDate).isAfter(moment(startDate))) {
                    _updates.startDate = startDate;
                }
                if (!isEmpty(_updates)) {
                    updateNode(parent, _updates);
                    return [
                        parent,
                        ...checkParent(parent)
                    ];
                }
                return [];
            }(id);
            // Check Dependent On
            [
                id,
                ...parentIds
            ].forEach((_id)=>{
                // preponeDependentsOn(_id, startDiff);
                if (isNewDependenciesEnabled) {
                    // postponeSuccessor(_id);
                    processDependenciesFor(_id);
                } else {
                    preponeDependentsOn(_id);
                }
            });
        // Check Children (for phase, not parent task)?
        };
        const handleStartDatePostpone = ()=>{
            // Move children
            const childNodeIds = getAllChildNodes(id);
            childNodeIds.forEach((childId)=>{
                const { startDate: currentStartDate, dueDate: currentDueDate } = getCurrentNode(childId);
                const child = getUpdatedNode(childId);
                if (moment(child.startDate).isSameOrAfter(moment(nodeStartDate))) {
                    return true;
                }
                const newStartDate = nodeStartDate;
                const _updates = {
                    startDate: newStartDate
                };
                const duration = _getCurrentDuration(childId, currentStartDate, currentDueDate);
                let newDueDate = _addDays(newStartDate, duration - 1, allowWeekend);
                if (moment(newDueDate).isAfter(moment(nodeDueDate))) {
                    newDueDate = nodeDueDate;
                }
                _updates.dueDate = newDueDate;
                updateNode(childId, _updates);
                if (isNewDependenciesEnabled) {
                    // postponeSuccessor(childId);
                    processDependenciesFor(childId);
                } else {
                    postponeDependenciesFor(childId);
                }
                return childId;
            });
            // Move phase not parent task
            /**
       * Postponse phase start date, not parent task
       * since parent task can have additional duration unlike a phase
       *
       * Latest product call: allow phase to have additional duration
       * similar to parent task, based on the config `alignParentWithChildren`
       */ const { parent } = getUpdatedNode(id);
            if (!parent) {
                return;
            }
            const parentNode = getUpdatedNode(parent);
            const isPhase = !parentNode.parent;
            let _updates = {};
            if (!alignParentWithChildren && !alignPhaseWithTask) {
                return;
            }
            if (isPhase) {
                _updates = getPhaseUpdates(parent);
                phasesToBeProcessed.push(parent);
            } else if (alignParentWithChildren) {
                const [newStartDate, newDueDate] = getPhaseDates(parent);
                if (!moment(parentNode.startDate).isSame(newStartDate)) {
                    _updates.startDate = moment(newStartDate).format(API_DATE_FORMAT);
                }
                if (!moment(parentNode.dueDate).isSame(newDueDate)) {
                    _updates.dueDate = moment(newDueDate).format(API_DATE_FORMAT);
                }
            }
            if (!isEmpty(_updates)) {
                updateNode(parent, _updates);
                processDependenciesFor(parent);
            }
        // Check due date overlap?
        };
        const handleDueDatePrepone = ()=>{
            // special check for templates
            if (alignParentWithChildren) {
                (function checkParent(_id) {
                    const { parent, dueDate } = getUpdatedNode(_id);
                    if (!parent) {
                        return [];
                    }
                    const parentNode = getUpdatedNode(parent);
                    const isPhase = !parentNode.parent;
                    let _updates = {};
                    if (alignParentWithChildren || alignPhaseWithTask) {
                        if (isPhase) {
                            _updates = getPhaseUpdates(parent);
                            phasesToBeProcessed.push(parent);
                        } else if (alignParentWithChildren) {
                            const [newStartDate, newDueDate] = getPhaseDates(parent);
                            if (!moment(parentNode.startDate).isSame(newStartDate)) {
                                _updates.startDate = moment(newStartDate).format(API_DATE_FORMAT);
                            }
                            if (!moment(parentNode.dueDate).isSame(newDueDate)) {
                                _updates.dueDate = moment(newDueDate).format(API_DATE_FORMAT);
                            }
                        } else if (moment(parentNode.dueDate).isBefore(moment(dueDate))) {
                            _updates.dueDate = dueDate;
                        }
                    } else if (moment(parentNode.dueDate).isBefore(moment(dueDate))) {
                        _updates.dueDate = dueDate;
                    }
                    if (!isEmpty(_updates)) {
                        updateNode(parent, _updates);
                        return [
                            parent,
                            ...checkParent(parent)
                        ];
                    }
                    return [];
                })(id);
            }
            // Check children
            const childNodeIds = getAllChildNodes(id);
            const updatedChildIds = [];
            childNodeIds.forEach((childId)=>{
                const { startDate: currentStartDate, dueDate: currentDueDate } = getCurrentNode(childId);
                const child = getUpdatedNode(childId);
                if (moment(child.dueDate).isSameOrBefore(moment(nodeDueDate))) {
                    return;
                }
                const newDueDate = nodeDueDate;
                const _updates = {
                    dueDate: newDueDate
                };
                const duration = _getCurrentDuration(childId, currentStartDate, currentDueDate);
                let newStartDate = _addDays(newDueDate, -(duration - 1), allowWeekend);
                if (moment(newStartDate).isBefore(moment(nodeStartDate))) {
                    newStartDate = nodeStartDate;
                }
                _updates.startDate = newStartDate;
                updateNode(childId, _updates);
                updatedChildIds.push(childId);
            });
            [
                id,
                ...updatedChildIds
            ].forEach((_id)=>{
                if (isNewDependenciesEnabled) {
                    // postponeSuccessor(_id);
                    processDependenciesFor(_id);
                } else {
                    preponeDependentsOn(_id);
                }
            });
            /**
       * Prepone phase due date, not parent task
       * since parent task can have additional duration unlike a phase
       *
       * Latest product call: allow phase to have additional duration
       * similar to parent task, based on the config `alignParentWithChildren`
       */ const { parent } = getUpdatedNode(id);
            if (!parent) {
                return;
            }
            const parentNode = getUpdatedNode(parent);
            const isPhase = !parentNode.parent;
            let _updates = {};
            if (alignParentWithChildren || alignPhaseWithTask) {
                if (isPhase) {
                    _updates = getPhaseUpdates(parent);
                    phasesToBeProcessed.push(parent);
                } else if (alignParentWithChildren) {
                    const [newStartDate, newDueDate] = getPhaseDates(parent);
                    if (!moment(parentNode.startDate).isSame(newStartDate)) {
                        _updates.startDate = moment(newStartDate).format(API_DATE_FORMAT);
                    }
                    if (!moment(parentNode.dueDate).isSame(newDueDate)) {
                        _updates.dueDate = moment(newDueDate).format(API_DATE_FORMAT);
                    }
                }
                if (!isEmpty(_updates)) {
                    updateNode(parent, _updates);
                    processDependenciesFor(parent);
                }
            }
        // Check start date overlap?
        };
        const handleDueDatePostpone = ()=>{
            // Move Parent
            const parentIds = function checkParent(_id) {
                const { parent, dueDate } = getUpdatedNode(_id);
                if (!parent) {
                    return [];
                }
                const parentNode = getUpdatedNode(parent);
                const isPhase = !parentNode.parent;
                let _updates = {};
                if (alignParentWithChildren || alignPhaseWithTask) {
                    if (isPhase) {
                        _updates = getPhaseUpdates(parent);
                        phasesToBeProcessed.push(parent);
                    } else if (alignParentWithChildren) {
                        const [newStartDate, newDueDate] = getPhaseDates(parent);
                        if (!moment(parentNode.startDate).isSame(newStartDate)) {
                            _updates.startDate = moment(newStartDate).format(API_DATE_FORMAT);
                        }
                        if (!moment(parentNode.dueDate).isSame(newDueDate)) {
                            _updates.dueDate = moment(newDueDate).format(API_DATE_FORMAT);
                        }
                    } else if (moment(parentNode.dueDate).isBefore(moment(dueDate))) {
                        _updates.dueDate = dueDate;
                    }
                } else if (moment(parentNode.dueDate).isBefore(moment(dueDate))) {
                    _updates.dueDate = dueDate;
                }
                if (!isEmpty(_updates)) {
                    updateNode(parent, _updates);
                    return [
                        parent,
                        ...checkParent(parent)
                    ];
                }
                return [];
            }(id);
            // Check Dependencies For
            [
                id,
                ...parentIds
            ].forEach((_id)=>{
                if (isNewDependenciesEnabled) {
                    // postponeSuccessor(_id);
                    processDependenciesFor(_id);
                } else {
                    postponeDependenciesFor(_id);
                }
            });
        // Check Children (for phase, not parent task)?
        };
        if (startDiff < 0) {
            handleStartDatePrepone();
        } else if (startDiff > 0) {
            handleStartDatePostpone();
        }
        if (endDiff < 0) {
            handleDueDatePrepone();
        } else if (endDiff > 0) {
            handleDueDatePostpone();
        }
    };
    let diff = getDateDiffForEntity(entity.id);
    // This logic helps in figuring out what dependencies will cause the successor move predecessors
    // const updatedNode = getUpdatedNode(entity.id);
    const conditions = diff.startDate > 0 && diff.dueDate > 0 || diff.startDate === 0 && diff.dueDate > 0 || diff.startDate > 0 && diff.dueDate === 0 || diff.startDate === 0 && diff.dueDate === 0 || !isNewDependenciesEnabled;
    if (!conditions || isNewDependenciesEnabled && (options === null || options === void 0 ? void 0 : options.newTaskCreation)) {
        const _allowWeekend = allowWeekendForEntityTree || allowWeekend;
        processChildren(entity.id, allowWeekendForEntityTree, _allowWeekend, diff.startDate, true);
        const parentIds = checkParentDuringShifting(entity.id, diff.startDate);
        const updatedNodes = [
            ...parentIds,
            entity.id
        ];
        updatedNodes.forEach((id)=>{
            processAsSuccessor(id, true);
        });
        if (!isEmpty(dependencyRelationsToDelete)) {
            // dependencyRelationsToDelete is an array of strings
            // "471-456" the first number is the task id and the second number is the dependent task id
            // find the task and remove the dependent task from the dependentOn array
            // loop through the dependencyRelationsToDelete array
            // the array can also contain phases
            dependencyRelationsToDelete.forEach((dependencyRelation)=>{
                const [id, dependentId] = dependencyRelation.split('-');
                if (tasks[id]) {
                    var _tasks_id_dependentOn, _tasks_id, _tasks_dependentId_dependencyFor, _tasks_dependentId;
                    const dependentOn = (_tasks_id = tasks[id]) === null || _tasks_id === void 0 ? void 0 : (_tasks_id_dependentOn = _tasks_id.dependentOn) === null || _tasks_id_dependentOn === void 0 ? void 0 : _tasks_id_dependentOn.filter((dependent)=>dependent.id !== parseInt(dependentId, 10));
                    tasks[id].dependentOn = dependentOn;
                    const dependencyFor = (_tasks_dependentId = tasks[dependentId]) === null || _tasks_dependentId === void 0 ? void 0 : (_tasks_dependentId_dependencyFor = _tasks_dependentId.dependencyFor) === null || _tasks_dependentId_dependencyFor === void 0 ? void 0 : _tasks_dependentId_dependencyFor.filter((dependency)=>dependency.id !== parseInt(id, 10));
                    tasks[dependentId].dependencyFor = dependencyFor;
                } else if (phases[id]) {
                    var _phases_id_dependentOn, _phases_id, _phases_dependentId_dependencyFor, _phases_dependentId;
                    const dependentOn = (_phases_id = phases[id]) === null || _phases_id === void 0 ? void 0 : (_phases_id_dependentOn = _phases_id.dependentOn) === null || _phases_id_dependentOn === void 0 ? void 0 : _phases_id_dependentOn.filter((dependent)=>dependent.id !== parseInt(dependentId, 10));
                    phases[id].dependentOn = dependentOn;
                    const dependencyFor = (_phases_dependentId = phases[dependentId]) === null || _phases_dependentId === void 0 ? void 0 : (_phases_dependentId_dependencyFor = _phases_dependentId.dependencyFor) === null || _phases_dependentId_dependencyFor === void 0 ? void 0 : _phases_dependentId_dependencyFor.filter((dependency)=>dependency.id !== parseInt(id, 10));
                    phases[dependentId].dependencyFor = dependencyFor;
                }
            });
        // empty updates
        }
        updates = {};
        updates = {
            [entity.id]: {
                ...entity
            }
        };
        if ((options === null || options === void 0 ? void 0 : options.fromTemplate) && !isEmpty(dependencyRelationsToDelete)) {
            return [
                updates,
                updates,
                updates,
                false,
                dependencyRelationsToDelete
            ];
        }
    }
    if (options === null || options === void 0 ? void 0 : options.newTaskCreation) {
        const { parent } = getUpdatedNode(entity.id);
        if (parent) {
            const { startDate, dueDate } = getUpdatedNode(parent);
            if (moment(startDate).isAfter(moment(entity.startDate))) {
                updateNode(parent, {
                    startDate: entity.startDate
                });
            }
            if (moment(dueDate).isBefore(moment(entity.dueDate))) {
                updateNode(parent, {
                    dueDate: entity.dueDate
                });
            }
            diff = getDateDiffForEntity(parent);
            entity = {
                ...getUpdatedNode(parent)
            };
        }
    }
    if (diff.duration === 0) {
        handleShift(entity.id, diff.startDate, {
            dependencyOperationsDone: options === null || options === void 0 ? void 0 : options.dependencyOperationsDone,
            processDependentsOn: true
        });
    } else {
        handleResize(entity.id, diff);
    }
    function collectParentIds(id) {
        const parentIds = [];
        function traverse(nodeId) {
            const { parent } = getUpdatedNode(nodeId);
            if (parent) {
                traverse(parent); // Recursively traverse to the parent
            }
            parentIds.push(nodeId); // Add the current node after traversing its parent
        }
        traverse(id); // Start the traversal
        return parentIds;
    }
    if (isNewDependenciesEnabled) {
        // Updated logic for checking boundaries
        checkParentTaskBoundaries.forEach((id)=>{
            const parentIds = collectParentIds(id);
            const { startDate, dueDate } = getUpdatedNode(id);
            parentIds.forEach((parentId)=>{
                const parentNode = getUpdatedNode(parentId);
                // Check and update startDate
                if (moment(parentNode.startDate).isAfter(moment(startDate))) {
                    updateNode(parentId, {
                        startDate
                    });
                }
                // Check and update dueDate
                if (moment(parentNode.dueDate).isBefore(moment(dueDate))) {
                    updateNode(parentId, {
                        dueDate
                    });
                }
                processDependenciesFor(parentId, false);
            });
        });
    }
    phasesToBeProcessed.forEach((_phaseId)=>{
        const _updates = getPhaseUpdates(_phaseId);
        if (!isEmpty(_updates)) {
            updateNode(_phaseId, _updates);
        }
        if (isNewDependenciesEnabled) {
            processDependenciesFor(_phaseId);
        }
    });
    let phaseUpdates = {};
    const taskUpdates = {};
    const sprintUpdates = {};
    Object.values(updates).forEach(({ type, ...rest })=>{
        if (type === 0) {
            phaseUpdates[rest.id] = rest;
        } else if (type === 1) {
            taskUpdates[rest.id] = rest;
        } else if (type === 2) {
            sprintUpdates[rest.id] = rest;
        }
    });
    const { phaseUpdates: _phaseUpdates, doesAffectOtherEntities } = doesEntityAffectOtherEntities(entity, taskUpdates, phaseUpdates, sprintUpdates, tasks, sprints, phases);
    if (Object.values(phaseUpdates).length <= 0) {
        phaseUpdates = _phaseUpdates;
    }
    return [
        phaseUpdates,
        taskUpdates,
        sprintUpdates,
        doesAffectOtherEntities || !isEmpty(dependencyRelationsToDelete),
        dependencyRelationsToDelete
    ];
};
